import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles({
  table: {
    width: "100%",
    // minWidth: 650,
    "& .MuiTableCell-root": {
      // padding: "8px 12px",
      lineHeight: "1.2",
      // fontSize: "0.8rem",
      //   verticalAlign: "top",
      //   fontSize: "12px",
    },
    // "& .MuiTableRow-root": {
    //   height: "auto",
    // },
  },
  headerCell: {
    fontWeight: 500,
    // fontSize: "0.8rem",
  },
  grayRow: {
    backgroundColor: "#f7f6f6", // Lighter gray for even rows
  },
  spaceBetween: {
    lineHeight: "2",
  },
  lotNumbers: {
    display: "block", // Use block to ensure vertical stacking of lot numbers
    lineHeight: "1.5",
  },
  stickyHeaderRow: {
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  tableContainer: {
    maxHeight: "500px", // Set a fixed height for the table container
    overflow: "auto", // Enable
    width: "100%",
  },
});

export default function LotTable({ apiData, loading, error }) {
  const classes = useStyles();

  // const transformedData = apiData?.map((item) => ({
  //   sponsorCode: `${item.sponsorMaterialCode ?? "NA"} / ${
  //     item.sponsorMaterialName ?? "NA"
  //   }`,
  //   cmoCode: `${item.cmoMaterialCode ?? "NA"} / ${
  //     item.cmoMaterialName ?? "NA"
  //   }`,
  //   bomQuantity: item.componentQuantity ?? "NA",
  //   uom: item.uom ?? "NA",
  //   netAvailableQty: item.netQuantityAvailable ?? "NA",
  //   lotNumbers: item.LotNumberList?.map((lot) => lot.lotNumber ?? "NA") ?? [
  //     "NA",
  //   ],
  //   plannedAllocation: item.LotNumberList?.map(
  //     (lot) => lot.plannedAllocatedQuantity ?? "NA"
  //   ) ?? ["NA"],
  //   actualAllocation: item.LotNumberList?.map(
  //     (lot) => lot.actualAllocatedQuantity ?? "NA"
  //   ) ?? ["NA"], // Placeholder, update if actual data is provided
  //   quantityVariance: 0, // Placeholder for calculation logic
  //   lotsMismatch: "NO", // Placeholder, needs validation logic
  // }));

  const displayLoading = (
    <TableRow>
      <TableCell colSpan={9} align="center">
        <CircularProgress color="primary" thickness={7} />
      </TableCell>
    </TableRow>
  );

  const tableError = (
    <TableRow
      style={{
        border: "2px solid #FF0000",
        backgroundColor: "#FFF0F0",
        marginTop: "10px",
      }}
    >
      <TableCell colSpan={9} align="center">
        Something went wrong. Please try again later.
      </TableCell>
    </TableRow>
  );

  const noRecordsFoundMsgDisplay = (
    <TableRow>
      <TableCell colSpan={9} align="center">
        No records found
      </TableCell>
    </TableRow>
  );

  const  mergeConsumptionWithPlanned = (allocationDetails, consumptionDetails)=>  {
    // Create a map for quick lookup of consumed quantities by batch number
    const consumptionMap = new Map();
    
    consumptionDetails.forEach(({ BomComponentConsumedQuantity, componentBatchNumber }) => {
        consumptionMap.set(componentBatchNumber, BomComponentConsumedQuantity);
    });

    // Merge planned allocation details with actual consumption
    let mergedDetails = allocationDetails.map(({ plannedAllocatedQuantity, lotNumber, plannedLotAllocation }) => {
        return {
            plannedAllocatedQuantity,
            lotNumber,
            plannedLotAllocation,
            BomComponentConsumedQuantity: consumptionMap.get(lotNumber) || null
        };
    });

    // Add any consumed batches that were not in planned allocation
    consumptionDetails.forEach(({ BomComponentConsumedQuantity, componentBatchNumber }) => {
        if (!allocationDetails.some(({ lotNumber }) => lotNumber === componentBatchNumber)) {
            mergedDetails.push({
                plannedAllocatedQuantity: null,
                lotNumber: componentBatchNumber,
                plannedLotAllocation: null,
                BomComponentConsumedQuantity
            });
        }
    });

    return mergedDetails;
}

  return (
    <Box style={{ marginTop: "1em" }}>
      <Typography variant="h6">
        <span
          style={{
            // fontWeight: "bold",
            borderBottom: "4px solid #a9a9a9",
            paddingBottom: "2px",
          }}
        >
          RM
        </span>
        /PM lots details
      </Typography>
      <TableContainer
        component={Paper}
        style={{ margin: "1em 0" }}
        className={classes.tableContainer}
      >
        <Table className={classes.table} stickyHeader >
          <TableHead>
            <TableRow
              className={`${classes.grayRow} ${classes.stickyHeaderRow}`}
            >
              <TableCell className={classes.headerCell} align="left">
                RM/PM code / description
              </TableCell>
              <TableCell className={classes.headerCell} align="right">BoM quantity</TableCell>
              <TableCell className={classes.headerCell} align="left" >UoM</TableCell>
              <TableCell className={classes.headerCell} align="right">
                Net available qty.
              </TableCell>
              <TableCell className={classes.headerCell} align="right">Batch numbers</TableCell>
              <TableCell className={classes.headerCell} align="right">
                Planned batch allocation
              </TableCell>
              <TableCell className={classes.headerCell} align="right">
                Actual batch allocation
              </TableCell>
              <TableCell className={classes.headerCell} align="right">
                Quantity variance (%)
              </TableCell>
              <TableCell className={classes.headerCell} align="center">
                Batches mismatch
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading
              ? displayLoading
              : error
              ? tableError
              : apiData?.length === 0
              ? noRecordsFoundMsgDisplay
                  : apiData?.map((row, index) => {

                    let allocation = mergeConsumptionWithPlanned(row?.plannedLotNumberAllocationDetails || [], row?.actualConsumptionDetails || [])
                    return (
                      <React.Fragment key={index}>
                        <TableRow
                          className={index % 2 === 1 ? classes.grayRow : ""}>
                          <TableCell
                            scope="row"
                          rowSpan={
                            allocation.length > 1 &&
                            allocation.length
                          }
                            align="left">
                          {row?.componentCode && row?.componentName
                            ? `${row.componentCode}/${row.componentName}`
                            : ""}
                        </TableCell>
                        <TableCell
                            scope="row"
                          rowSpan={
                            allocation.length > 1 &&
                            allocation.length
                          }
                            align="right">
                            {/* {row?.componentQuantity ? Number(row?.componentQuantity).toFixed(3) : "NA"} */}
                            {/* {(row?.BOMQuantity || row?.BOMQuantity == 0) ? Number(row?.BOMQuantity).toFixed(3) : "NA"} */}
                          {(row?.componentQuantity || row?.componentQuantity == 0) ? Number(row?.componentQuantity).toFixed(3) : ""}
                        </TableCell>
                        <TableCell
                            scope="row"
                          rowSpan={
                            allocation.length > 1 &&
                            allocation.length
                          }
                            align="left">
                          {row?.uom ? row?.uom : ""}
                        </TableCell>
                        <TableCell
                            scope="row"
                          rowSpan={
                            allocation.length > 1 &&
                            allocation.length
                          }
                            align="right">
                          {row?.netAvailableQuantity || row?.netAvailableQuantity == 0
                            ? Number(row?.netAvailableQuantity).toFixed(3)
                            : ""}
                        </TableCell>
                        <TableCell align="right">
                            {allocation.length > 0
                              ? (allocation[0].lotNumber ? allocation[0].lotNumber : '')
                            :''}
                    
                        </TableCell>
                        <TableCell align="right">
                          {/* {allocation.length > 0
                              ? (allocation[0].plannedLotAllocation ? Number(allocation[0].plannedLotAllocation).toFixed(3) : 0)
                            :0} */}
                            {allocation.length > 0
                              ? (allocation[0].plannedAllocatedQuantity ? Number(allocation[0].plannedAllocatedQuantity).toFixed(3) : 0)
                            :0}
                        </TableCell>
                        <TableCell align="right">
                            {allocation.length > 0 ?
                              (allocation[0].BomComponentConsumedQuantity ? Number(allocation[0].BomComponentConsumedQuantity).toFixed(3) : 0)
                            :0}
                        </TableCell>
                        


                        <TableCell
                            scope="row"
                          rowSpan={
                            allocation.length > 1 &&
                            allocation.length
                          }
                            align="right">
                          {row?.quantityVariance || row?.quantityVariance === 0  ? Number(row?.quantityVariance).toFixed(0) : 0}
                        </TableCell>
                        <TableCell
                            scope="row"
                          rowSpan={
                            allocation.length > 1 &&
                            allocation.length
                          }
                            align="center">
                          {row?.lotMismatch ? "Yes" : "No"}
                        </TableCell>
                      </TableRow>
                        {allocation.length > 1 &&
                          allocation
                        .slice(1)
                        .map((val, i) => (
                          <TableRow key={i}
                            className={index % 2 === 1 ? classes.grayRow : ""}
                          >
                            {/* <TableCell ></TableCell>
                            <TableCell ></TableCell>
                            <TableCell ></TableCell>
                            <TableCell ></TableCell> */}
                            <TableCell align="right">
                            {val.lotNumber ? val.lotNumber :''}
                    
                        </TableCell>
                        <TableCell align="right">
                          {/* {val.plannedLotAllocation ?  Number(val.plannedLotAllocation).toFixed(3) : 0} */}
                        {val.plannedAllocatedQuantity ?  Number(val.plannedAllocatedQuantity).toFixed(3) : 0}
                        </TableCell>
                        <TableCell align="right">
                        {val.BomComponentConsumedQuantity ? Number(val.BomComponentConsumedQuantity).toFixed(3) : 0}
                            </TableCell>
                            {/* <TableCell ></TableCell>
                            <TableCell ></TableCell> */}
                          </TableRow>
                        ))
                    }
                    </React.Fragment>
                    )
                  })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
